module.exports = __webpack_public_path__ + "static/media/detalj.3014b0d0.mp3";